<template>
  <div>
    <div class="transcription-sentences">
      <div class="sentence">
        <div class="sentence-time">
            <span class="time-badge">
              00:00
            </span>
        </div>
        <div class="sentence-content">
          <b-skeleton animation></b-skeleton>
          <b-skeleton animation></b-skeleton>
          <b-skeleton animation></b-skeleton>
          <b-skeleton animation></b-skeleton>
          <br>
        </div>
      </div>
      <div class="sentence">
        <div class="sentence-time">
            <span class="time-badge">
              00:15
            </span>
        </div>
        <div class="sentence-content">
          <b-skeleton animation></b-skeleton>
          <b-skeleton animation></b-skeleton>
          <br>
        </div>
      </div>
      <div class="sentence">
        <div class="sentence-time">
            <span class="time-badge">
              00:30
            </span>
        </div>
        <div class="sentence-content">
          <b-skeleton animation></b-skeleton>
          <b-skeleton animation></b-skeleton>
          <b-skeleton animation></b-skeleton>
          <br>
        </div>
      </div>
      <div class="sentence">
        <div class="sentence-time">
            <span class="time-badge">
              00:45
            </span>
        </div>
        <div class="sentence-content">
          <b-skeleton animation></b-skeleton>
          <br>
        </div>
      </div>
    </div>
    <transcription-skeleton-overlay></transcription-skeleton-overlay>
  </div>
</template>

<script>

import TranscriptionSkeletonOverlay from '@cmp/viewer/transcription_skeleton_overlay.vue';

export default {
  components: {
    TranscriptionSkeletonOverlay
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
  @import '@/packs/colors.scss';

  .transcription-sentences {
    display: flex;
    flex-direction: column;
    position: relative;
    opacity: .2;

    .sentence {
      display: flex;
    }

    .sentence-content {
      padding: 1rem 1rem 0;
      flex-grow: 1;
    }

    .sentence-time {
      padding: 1rem 0;
      // matches avatar width in comments section so they look the same
      min-width: 68px;
      text-align: center;
    }

    .time-badge {
      padding: 0.063rem 0.281rem 0.125rem 0.281rem;
      border-radius: 10px;
      background-color: $silver-chalice;
      color: white;
      font-size: .7rem;
      font-weight: bolder;
      cursor: not-allowed;
    }

    .b-skeleton {
      cursor: not-allowed;
    }
  }
</style>
